import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appAutoFocus]',
    standalone: false
})
export class AutofocusDirective implements AfterContentInit
{

  @Input() public appAutoFocus: boolean;

  public constructor(private el: ElementRef)
  {

  }

  public ngAfterContentInit()
  {
    this.el.nativeElement.focus();
  }
}
